import { Button, Grid, InputBase, Typography } from "@material-ui/core";
import { setInvitationKey } from "../../constants";
import { useState } from "react";
import { ConfirmInvite } from "../../constants";
import { useHistory } from "react-router";
import { Alert } from "@material-ui/lab";
import { useSelector } from "react-redux";

function Invitation() {
  const [key, setKey] = useState("");
  const [alert, setAlert] = useState(false);
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);
  const history = useHistory();
  return (
    <>
      {alert ? (
        <Alert
          severity="error"
          onClose={() => {
            setAlert(false);
          }}
        >
          Invitation Key is not Valid!
        </Alert>
      ) : null}

      <div
        style={{
          minHeight: isDesktopOrLaptop ? "90vh" : "45vh",
          width: "100%",
          backgroundImage: isDesktopOrLaptop
            ? "linear-gradient(180deg, #0C3459 0%, #0C3459 16.15%, #438DD2 72.43%)"
            : "linear-gradient(to bottom, #0c345c, #506c9c)",
        }}
      >
        <Grid container justify="center">
          {/* <Grid
            container
            justify="center"
            style={{ marginTop: isDesktopOrLaptop ? "30vh" : "8vh" }}
          >
            <img src={logo} alt="logo"></img>
          </Grid> */}
          {/* <Grid
            container
            justify="center"
            style={{
              marginBottom: "6vh",
              paddingTop: isDesktopOrLaptop ? "2vh" : "1vh",
            }}
          >
            <img src={tagLine} alt="logo"></img>
          </Grid> */}
        </Grid>
        <Grid
          container
          justify="center"
          style={{
            marginTop: "30vh",
          }}
        >
          <Typography
            style={{ color: "#FFFFFF", fontFamily: "Varela Round" }}
            className="tagLine"
          >
            Please enter your invitation key:
          </Typography>
        </Grid>
        <Grid container justify="center">
          <Grid
            item
            xs={isDesktopOrLaptop ? 4 : 12}
            style={{
              paddingTop: "10px",
              paddingLeft: isDesktopOrLaptop ? null : "5vw",
              paddingRight: isDesktopOrLaptop ? null : "5vw",
            }}
          >
            <Grid
              container
              style={{
                backgroundColor: "#FAFAFA",
                borderRadius: "5px",
                alignItems: "center",
                paddingTop: "5px",
                paddingBottom: "5px",
              }}
            >
              <Grid item xs={isDesktopOrLaptop ? 10 : 9}>
                <InputBase
                  value={key}
                  style={{
                    fontWeight: 300,
                    fontSize: "18px",
                    color: "#282727",
                    width: "100%",
                    fontFamily: "Source Sans Pro",
                    paddingLeft: "5px",
                    paddingRight: "5px",
                  }}
                  onChange={(e) => {
                    setKey(e.target.value);
                  }}
                  // onKeyDown={(e) => {
                  //   if (e.key === "Enter") {
                  //     setSearched(false);
                  //     setSearchedState({
                  //       name: searchKeyword,
                  //       ISIN: null,
                  //     });
                  //     setSearchKeyword("");
                  //     history.push("/search-results");
                  //   }
                  // }}
                />
              </Grid>

              <Grid
                item
                xs={isDesktopOrLaptop ? 2 : 3}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Button
                  variant="outlined"
                  size="small"
                  style={{
                    backgroundColor: "#438DD2",
                    color: "#FAFAFA",
                    marginRight: "5px",
                  }}
                  onClick={async () => {
                    const confirm = await ConfirmInvite(key);
                    if (confirm != "Denied") {
                      await setInvitationKey(key);
                      history.push("/home");
                      history.go(0);
                    } else {
                      setAlert(true);
                      setTimeout(() => {
                        setAlert(false);
                      }, 3000);
                    }
                  }}
                >
                  Enter
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
      {isDesktopOrLaptop ? null : (
        <>
          <div
            style={{
              minHeight: "45vh",
              backgroundImage:
                "linear-gradient(180deg, #506c9c 0%, #000000 40.75%)",
            }}
          ></div>
        </>
      )}
    </>
  );
}

export default Invitation;
